import React from 'react';
import { noop } from 'lodash';
import { Button } from 'tuui';
import { FormattedMessage } from '../../taboola-common-frontend-modules/i18n';
import { ConnectedCustomAccountDropdown } from './CustomAccountDropdown';
import styles from '../pages/thirdPartyConnect.module.scss';

export const SelectAccount = ({ onCancel, onConnect, onAccountSelect, selectedAccount }) => {
    return (
        <div className={styles['select-account']}>
            <h1 className={styles.title}>
                <FormattedMessage id="3p-connect.select-account.title" defaultMessage="Select the account to connect" />
            </h1>
            <p>
                <FormattedMessage
                    id="3p-connect.select-account.content"
                    defaultMessage="Connect your Realize account with your website to start tracking conversions. Select Your Realize Account"
                />
            </p>
            <div className={styles['account-picker-container']}>
                <ConnectedCustomAccountDropdown
                    accountForCampaign={selectedAccount}
                    onAccountChange={onAccountSelect}
                    helpText={
                        <FormattedMessage
                            id="3p-connect.intro.help"
                            defaultMessage="Select the account you want to connect."
                        />
                    }
                    className={styles['account-picker-dropdown']}
                />
            </div>
            <div className={styles['buttons-container']}>
                <Button variant={Button.variant.ghost} className={styles['button']} onClick={onCancel}>
                    <FormattedMessage id="3p-connect.button.back" defaultMessage="Back" />
                </Button>
                <Button className={styles['button']} onClick={onConnect} disabled={!selectedAccount?.id}>
                    <FormattedMessage id="3p-connect.button.connect" defaultMessage="Connect" />
                </Button>
            </div>
        </div>
    );
};

SelectAccount.defaultProps = {
    onAccountSelect: noop,
    selectedAccount: null,
};
